import { getPaletteAsRawColors } from 'owa-theme';
import type { IButtonStyles } from '@fluentui/react/lib/Button';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> 'lodash-es/assign' import is restricted from being used. lodash-es/assign increases bundle size. Use native function instead. */
import assign from 'lodash-es/assign';

const getPrimaryButtonStyles = (styles?: IButtonStyles, themeColor?: string): IButtonStyles => {
    const customColor: string = themeColor || getPaletteAsRawColors().themePrimary || '';

    return assign({}, styles, {
        root: assign(
            {
                backgroundColor: customColor,
                borderRadius: 4,
                minHeight: 36,
                border: 'none',
                padding: '0 12px', // This is the padding provided by Fluent used across Figma
            },
            styles?.root
        ),
        rootHovered: assign(
            {
                backgroundColor: getPaletteAsRawColors().themeDarkAlt,
                border: 'none',
            },
            styles?.rootHovered
        ),
        rootPressed: assign(
            {
                backgroundColor: getPaletteAsRawColors().themeDarker,
                border: 'none',
            },
            styles?.rootPressed
        ),
        rootDisabled: assign(
            {
                backgroundColor: getPaletteAsRawColors().neutralLight,
                border: 'none',
            },
            styles?.rootDisabled
        ),
        label: assign({ fontWeight: 600 }, styles?.label),
        labelDisabled: assign(
            { color: getPaletteAsRawColors().buttonDisabledText },
            styles?.labelDisabled
        ),
        icon: assign(
            {
                height: 20,
                lineHeight: 20,
                /** Do not set margin to 0 which is usually the case in Figma
                 * doing that will screw the horizontalAlign='center' when icon
                 * and text are used together */
            },
            styles?.icon
        ),
    });
};

export default getPrimaryButtonStyles;
